import React, { useCallback, useEffect, useState } from 'react';
import { useBeforeunload } from 'react-beforeunload';
import { FormikValues, useFormikContext } from 'formik';
import _isEqual from 'lodash/isEqual';
import * as Schema from '../../types/schema';
import { diffObjects } from '../../helpers';
import { FormProps } from '../../components/Form/Form';
import { traverseSchema } from '../../app/schema';

interface Props extends FormProps {
	onUpdateSchema: (schema: Schema.Schema) => void;
}

function find(n: any, id: string) {
	return (n.id && n.id === id) || (n.name && n.name === id);
}

export const ChangesWrapper: React.FC<Props> = (props) => {
	const { schema, children, onInit, onChange, onCancelWhenModified, onUpdateSchema, form } = props;
	const { dirty } = form;
	const { values, errors, setValues } = useFormikContext<FormikValues>();
	const [prevValues, setPrevValues] = useState<FormikValues>(values);

	useBeforeunload((event: BeforeUnloadEvent) => {
		if (dirty && onCancelWhenModified) {
			event.preventDefault();
			return onCancelWhenModified();
		}
		return undefined;
	});

	const getArgs = () => {
		return {
			values,
			errors,
			changedValues: diffObjects(values, prevValues),
			schema,
			setValues,
			setSchema: (updated: Schema.Schema) => {
				onUpdateSchema(updated);
			},
			getSchemaNode: (id: string) => {
				let node: Schema.SchemaNode | null = null;
				traverseSchema(schema, (n: Schema.SchemaNode) => {
					if (find(n, id)) {
						node = { ...n };
					}
					return n;
				});
				return node;
			},
			setSchemaNode: (id: string, node: Schema.SchemaNode) => {
				const updated = traverseSchema(schema, (n: Schema.SchemaNode) => {
					if (find(n, id)) return node;
					return n;
				});
				onUpdateSchema(updated);
			},
			form,
		};
	};

	useEffect(() => {
		if (onInit) {
			onInit(getArgs());
		}
	}, []);

	useEffect(() => {
		if (onChange && !_isEqual(values, prevValues)) {
			onChange(getArgs());
		}
		setPrevValues(values);
	}, [values]);

	return <React.Fragment>{children}</React.Fragment>;
};
